import Vue from 'vue'
import Vuex from 'vuex'

import acmfReportList from './modules/acmfReportList'
import acmfReportDetails from './modules/acmfReportDetails'
import admin from './modules/admin'
import alertType from './modules/alertType'
import analyticComparison from './modules/analyticComparison'
import analyticModule from './modules/analyticModule'
import analytics from './modules/analytics'
import analyticsManagement from './modules/analyticsManagement'
import airlineManagement from './modules/airlineManagement'
import attachments from './modules/attachments'
//import auth from './modules/auth'
import customAlerts from './modules/customAlert'
import connectivity from './modules/connectivity'
import dplf from './modules/dplf'
import feature from './modules/feature'
import featureFlag from './modules/featureFlag'
import fleet from './modules/fleet'
import filters from './modules/filters'
import flightAware from './modules/flightAware'
import fullflight from './modules/fullflight'
import globalFilter from './modules/globalFilter'
import issueType from './modules/issueType'
import lookups from './modules/lookups'
import maintenanceIssues from './modules/maintenanceIssues'
import messages from './modules/messages'
import plot from './modules/plot'
import plotly from './modules/plotly'
import shared from './modules/shared'
import user from './modules/user'
import watchlist from './modules/watchlist'
import widgets from './modules/widgets'
import userGuide from './modules/userGuide'
import flightPhase from './modules/flightPhase'
import subscriptionCenter from './modules/subscriptionCenter'
import derivedParameters from './modules/derivedParameter'
import powerBi from './modules/powerBi'
import anserTool from './modules/anserTool'
import roleManagement from './modules/roleManagement'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sizeUpdate: false,
    cookieAlertSeen: window.localStorage.getItem('cookiesAccepted'),
    ipValidated: false,
    ipValid: false,
    currentEccn: null,
    apiDown: false,
    apiPageFailure: [],
    apiPageRequests: [],
  },
  mutations: {
    updateSize: (state, val) => {
      state.sizeUpdate = val
    },
    updateIPValidation: (state, val) => {
      state.ipValidated = true
      state.ipValid = val
    },
    updateCookieAlertSeen: (state, val) => {
      window.localStorage.setItem('cookiesAccepted', val)
      state.cookieAlertSeen = val
    },
    updateCurrentEccn: (state, eccnName) => {
      state.currentEccn = eccnName
    },
    updateApiDown: (state, val) => {
      state.apiDown = val
    },
    updateApiCallStatus: (state, val) => {
      // this keeps an array of api calls and their status
      // if a URL comes through with a fail, add it to the array (if it's not already there)
      // if it comes through with a pass, remove it from the array if it's there
      if (val === 'reset') {
        state.apiPageFailure = []
        state.apiPageRequests = []
      } else {
        const urlToLog = val.url
        const status = val.status
        const pageName = val?.pageName
        if (status === 'fail') {
          // check the api page requests array to see if it was made on this page
          // if the request was not made on the current page, ignore.  No need to show error
          const wasThisRequestMadeOnThisPage = state.apiPageRequests.filter(
            obj => {
              return obj.url === urlToLog && obj.pageName === pageName
            },
          )
          if (wasThisRequestMadeOnThisPage.length > 0) {
            // if request WAS made on the current page, add it to error array to show
            const hasFailedBefore = state.apiPageFailure.filter(obj => {
              return obj.url === urlToLog
            })
            if (hasFailedBefore.length === 0) {
              state.apiPageFailure.push({
                url: urlToLog,
              })
            }
          }
        } else if (status === 'pass') {
          const urlRemovedFromFailureArray = state.apiPageFailure.filter(
            obj => {
              return obj.url !== urlToLog
            },
          )
          state.apiPageFailure = urlRemovedFromFailureArray
          const urlRemovedFromRequestArray = state.apiPageRequests.filter(
            obj => {
              return obj.url !== urlToLog
            },
          )
          state.apiPageRequests = urlRemovedFromRequestArray
        } else if (status === 'new') {
          state.apiPageRequests.push({
            url: urlToLog,
            pageName: pageName,
          })
        }
      }
    },
  },
  modules: {
    acmfReportList,
    acmfReportDetails,
    admin,
    alertType,
    analyticComparison,
    analyticModule,
    analytics,
    analyticsManagement,
    airlineManagement,
    attachments,
    //auth,
    connectivity,
    customAlerts,
    dplf,
    feature,
    featureFlag,
    fleet,
    filters,
    flightAware,
    fullflight,
    globalFilter,
    issueType,
    lookups,
    maintenanceIssues,
    messages,
    plot,
    plotly,
    shared,
    user,
    watchlist,
    widgets,
    userGuide,
    flightPhase,
    subscriptionCenter,
    derivedParameters,
    powerBi,
    anserTool,
    roleManagement,
  },
})
